<template>
    <div class="hz-launcher" v-if="currentConfig" @click="toggleWechatStyle"
        :style="appStyle"
         :class="showModelClass?'hz-opened':'hz-close'">
        <div class="hz-launcher-box hz_assit_btn">
            <div class="hz-new-messsages-count" v-if="!showChatModel&&noSeeMsgList.length>0&&!showNoMsgModel">
            {{noSeeMsgList.length}}
            </div>
            <div class="hz-closed-icon"  :style="{backgroundColor:currentConfig.btnColor}" v-show="showChatModel">
<!--                <i class="el-icon-close" style="font-size: 30px;padding: 9px;border-radius: 48px"></i>-->
                <i class="hz-icon-close_icon icon-chat_icon"></i>
            </div>
            <div v-show="!showChatModel" class="chat_btn_model" :style="{backgroundColor:currentConfig.btnColor}">
                <div class="hz-open-icon hz_assit_btn"  >
                    <i class="hz-icon-chat_icon icon-chat_icon hz_assit_btn"></i>
                </div>
                <span class="hz-launcher--text hz_assit_btn"  v-if="currentConfig.btnText.length>0">{{multyLang&&multyLang[currentConfig.btnText]?multyLang[currentConfig.btnText][currentTranslateCode]:"chat us"}}</span>
            </div>

        </div>
    </div>
</template>


<script>
    import {store, mutations} from '../store/index'
    import {creatConversionDiv} from "@/util/util";
    export default {
        name: "chatBtn",
        props: {
            currentConfig: {
                type: Object,
                default() {
                    return {}
                }
            },
            appStyle: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {
                showModelClass:false,
                // showChatModel:false,
                // noSeeMsgList:['eee']
            }
        },
        computed: {
            showChatModel() {
                setTimeout(()=>{
                    this.showModelClass = store.showChatModel
                },100)
                return store.showChatModel;
            },
            multyLang(){
                return store.multyLang
            },
            currentTranslateCode(){
                return store.currentTranslateCode
            },
            showNoMsgModel(){
                return store.showNoMsgModel
            },
            noSeeMsgList() {
                return store.noSeeList;
            },
            conversionConfigId() {
              return store.conversionConfigId;
            },
        },
        methods: {
            toggleWechatStyle() {
                let flag = !this.showChatModel
                mutations.setShowChatModel(flag);
                this.conversionTriggerFn();
            },
            conversionTriggerFn() {
              if(this.conversionConfigId == 2){
                creatConversionDiv();
              }
            },
        }
    }
</script>

<style lang="scss" scoped>
@function px2rem($px) {
  @return $px / 18 * 1rem;
}
    #hz_chat_app {
        .hz-launcher {
            -moz-user-select:none;/*火狐*/
            -webkit-user-select:none;/*webkit浏览器*/
            -ms-user-select:none;/*IE10*/
            -khtml-user-select:none;/*早期浏览器*/
            user-select:none;
            pointer-events: auto;
            i{
                color: #ffffff;
            }

            min-width: 48px;
            height: 48px;
            background-position: center;
            background-repeat: no-repeat;
            position: absolute;
            /*right: 25px;*/
            bottom: 25px;
            border-radius: 48px;
            box-shadow: none;
            cursor: pointer;
            background: none;
            .hz-launcher-box {
                position: relative;
                min-width: 48px;
                height: 48px;
            }

            &.hz-launcher:before {
                /*content: '';*/
                position: relative;
                display: block;
                width: 48px;
                height: 48px;
                border-radius: 50%;
                transition: box-shadow 0.2s ease-in-out;
            }

            &.hz-launcher .chat_btn_model{
                display: inline-block;
                opacity: 1;
                transform: scale(1);
                border-radius: 60px;
                transition: opacity 280ms ease-in-out, transform 280ms ease-in-out,box-shadow 0.2s ease-in-out;
            }
            &.hz-launcher.hz-opened .chat_btn_model{
                opacity: 0;
                transform: scale(0);
            }
            .icon-chat_icon{
                font-size: 24px;
            }
            &.hz-launcher .hz-open-icon{
                width: 48px;
                height: 48px;
                font-size: 20px;
                color: #fff;
                display: inline-block;
                line-height: 48px;
                box-sizing: border-box;
                transform: rotate(360deg);
                transition: transform 280ms ease-in-out;
            }

            &.hz-launcher .hz-closed-icon {
                transition: opacity 280ms ease-in-out, transform 280ms ease-in-out ,box-shadow 0.2s ease-in-out;
                width: 48px;
                height: 48px;
                //font-size: 30px;
                border-radius: 50%;
                text-align: center;
                line-height: 48px;
                opacity: 0;
                transform: rotate(0deg) scale(0);
            }

           &.hz-launcher.hz-opened .hz-open-icon {
                transform: rotate(0deg);
            }

            &.hz-launcher.hz-opened .hz-closed-icon {
                transform: rotate(180deg) scale(1);
                opacity: 1;
            }

            &.hz-launcher:hover .chat_btn_model {
                box-shadow: 0 0px 27px 1.5px rgba(0, 0, 0, 0.2);
            }
            &.hz-launcher:hover .hz-closed-icon{
                box-shadow: 0 0px 27px 1.5px rgba(0, 0, 0, 0.2);
            }
            .hz-launcher--text {
                color: #fff;
                padding-right: 20px;
                font-size: 20px;
                float: right;
                line-height: 48px;
            }

            .hz-new-messsages-count {
                position: absolute;
                top: -6px;
                right: 0px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                border-radius: 50%;
                width: 22px;
                height: 22px;
                background: #ff4646;
                color: white;
                text-align: center;
                margin: auto;
                font-size: 12px;
                font-weight: 500;
                z-index: 999999;
            }
        }

      @media screen and (pointer: coarse) {
        .hz-launcher {
          -moz-user-select:none;/*火狐*/
          -webkit-user-select:none;/*webkit浏览器*/
          -ms-user-select:none;/*IE10*/
          -khtml-user-select:none;/*早期浏览器*/
          user-select:none;
          pointer-events: auto;
          i{
            color: #ffffff;
          }

          min-width: 48px;
          min-width: 36px;
          //min-width: px2rem(48);
          min-width: 48px;
          min-width: 36px;
          height: 48px;
          height: 36px;
          //height: px2rem(48);
          background-position: center;
          background-repeat: no-repeat;
          position: absolute;
          /*right: 25px;*/
          bottom: 25px;
          //bottom: px2rem(25);
          border-radius: 48px;
          //border-radius: px2rem(48);
          box-shadow: none;
          cursor: pointer;
          background: none;
          .hz-launcher-box {
            position: relative;
            min-width: 48px;
            min-width: 36px;
            //min-width: px2rem(48);
            height: 48px;
            height: 36px;
            //height: px2rem(48);
          }

          &.hz-launcher:before {
            /*content: '';*/
            position: relative;
            display: block;
            width: 48px;
            width: 36px;
            //width: px2rem(48);
            height: 48px;
            height: 36px;
            //height: px2rem(48);
            border-radius: 50%;
            transition: box-shadow 0.2s ease-in-out;
          }

          &.hz-launcher .chat_btn_model{
            display: inline-block;
            opacity: 1;
            transform: scale(1);
            border-radius: 60px;
            //border-radius: px2rem(60);
            transition: opacity 280ms ease-in-out, transform 280ms ease-in-out,box-shadow 0.2s ease-in-out;
          }
          &.hz-launcher.hz-opened .chat_btn_model{
            opacity: 0;
            transform: scale(0);
          }
          .icon-chat_icon{
            font-size: 18px;
            //font-size:px2rem(24);
          }
          &.hz-launcher .hz-open-icon{
            width: 48px;
            width: 36px;
            //width: px2rem(48);
            height: 48px;
            height: 36px;
            //height: px2rem(48);
            font-size: 20px;
            font-size: 16px;
            //font-size: px2rem(20);
            color: #fff;
            display: inline-block;
            line-height: 48px;
            line-height: 36px;
            //line-height: px2rem(48);
            box-sizing: border-box;
            transform: rotate(360deg);
            transition: transform 280ms ease-in-out;
          }

          &.hz-launcher .hz-closed-icon {
            transition: opacity 280ms ease-in-out, transform 280ms ease-in-out ,box-shadow 0.2s ease-in-out;
            width: 48px;
            width: 36px;
            //width: px2rem(48);
            height: 48px;
            height: 36px;
            //height: px2rem(48);
            //font-size: 30px;
            border-radius: 50%;
            text-align: center;
            line-height: 48px;
            line-height: 36px;
            //line-height: px2rem(48);
            opacity: 0;
            transform: rotate(0deg) scale(0);
          }

          &.hz-launcher.hz-opened .hz-open-icon {
            transform: rotate(0deg);
          }

          &.hz-launcher.hz-opened .hz-closed-icon {
            transform: rotate(180deg) scale(1);
            opacity: 1;
          }

          &.hz-launcher:hover .chat_btn_model {
            box-shadow: 0 0px 27px 1.5px rgba(0, 0, 0, 0.2);
          }
          &.hz-launcher:hover .hz-closed-icon{
            box-shadow: 0 0px 27px 1.5px rgba(0, 0, 0, 0.2);
          }
          .hz-launcher--text {
            color: #fff;
            padding-right: 20px;
            //padding-right: px2rem(20);
            font-size: 18px;
            //font-size: px2rem(20);
            float: right;
            line-height: 48px;
            line-height: 36px;
            //line-height: px2rem(48);
          }

          .hz-new-messsages-count {
            position: absolute;
            top: -6px;
            right: 0px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            border-radius: 50%;
            width: 22px;
            //width: px2rem(22);
            height: 22px;
            //height: px2rem(22);
            background: #ff4646;
            color: white;
            text-align: center;
            margin: auto;
            font-size: 12px;
            //font-size: px2rem(12);
            font-weight: 500;
            z-index: 999999;
          }
        }

        .hz-launcher {
          bottom: 70px;
          //bottom: px2rem(70);

        }
      }
    }

</style>
